import { categoryByName, categoryBySymbol } from 'common/constants';
import { visualizationTypes } from 'components/constants';
import { VisualizationType } from 'components/types';
import { useEffect, useState } from 'react';

interface SelectViewProps {
  selectedVisualization: VisualizationTypeDefault;
  setSelectedVisualization: (value: VisualizationTypeDefault) => void;
  selectedInstrument: DefaultItem | undefined;
}

function SelectView({
  selectedVisualization,
  setSelectedVisualization,
  selectedInstrument,
}: SelectViewProps) {
  const [visualizationTypesList, setVisualizationTypesList] = useState<VisualizationType[]>(visualizationTypes);

  useEffect(() => {
    if(selectedInstrument && categoryByName[selectedInstrument] !== 'Precious Metals') {
       const filteredTypes = visualizationTypes.filter(item => item.id !== 'charts');
       setVisualizationTypesList(filteredTypes);
       if( selectedVisualization === 'charts') {
         setSelectedVisualization(filteredTypes[0].id);
       }
    } else {
      setVisualizationTypesList(visualizationTypes);
    }
  }, [selectedInstrument]);

  return (
    <div>
      <select
        value={selectedVisualization}
        onChange={(e) => {
          const found = visualizationTypes.find((v) => v.id === e.target.value);
          if (found) {
            setSelectedVisualization(found.id);
          }
        }}
        className='mr-2 lg:mr-2 p-1 text-[14px] rounded border bg-white dark:bg-gray-700 text-gray-900 dark:text-white h-[32px]'
      >
        {visualizationTypesList.map((vizType) => (
          <option key={vizType.id} value={vizType.id}>
            {vizType.name}
          </option>
        ))}
      </select>
    </div>
  );
}

export default SelectView;
